var map = {
	"./base.png": "6472",
	"./black.png": "831c",
	"./gold.png": "f8ae",
	"./pink.png": "f1c8",
	"./promo.png": "efa7",
	"./rainbow.png": "79cb",
	"./red.png": "bd4e",
	"./silver.png": "eb79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fefc";